<template>
  <section>
    <div class="location-details" :class="{ desktop: $isDesktop }">
      <div v-if="$isDesktop" v-thtml="formatAddress" class="address" />
      <directions-button
        :address="userAddress"
        :point="campsite.point"
        :name="campsite.name"
      />
      <div v-if="!$isDesktop" v-thtml="formatAddress" class="address" />
      <slot />
    </div>
    <div class="map-holder" @click.prevent="mapClick">
      <client-only v-if="$isDesktop">
        <lazy-campsites-map v-bind="mapProps" :centre="campsite.point">
          <template #popup="{ markerData }">
            {{ markerData.name }}
          </template>
        </lazy-campsites-map>
      </client-only>
      <pu-map-static v-else :centre="staticMapProps.center" :zoom="12" />
    </div>
  </section>
</template>

<script lang="ts">
import type { MapCampsite } from '~/apps/maps/domain/MapsCampsite'
import { getPointFromStringOrDefault } from '~/utility/geo/latLng'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { CampsitesMapProps } from '../../maps/components/campsites/CampsitesMapProps'

@Component
class CampsiteAddressAndMap extends Vue {
  @Prop({ required: true })
  campsite: MapCampsite

  @Prop({ required: true })
  campsiteAddress: string

  @Prop({ default: '' })
  userAddress: string

  get formatAddress() {
    if (this.campsiteAddress) {
      return `${this.campsite.name}, ${this.campsiteAddress}`
        .split(', ')
        .map((el) => `<p>${el}</p>`)
        .join('')
    }
    return ''
  }

  get mapProps(): CampsitesMapProps {
    return {
      campsites: [this.campsite],
      isCampsiteDetails: true,
      zoomControl: !!this.$isDesktop,
    }
  }

  get staticMapProps() {
    const center = this.campsite.position
      ? this.campsite.position
      : getPointFromStringOrDefault(this.campsite.point)

    return {
      center,
    }
  }

  mapClick() {
    const mapModalButton = document.querySelector('.map-link') as HTMLElement
    if (mapModalButton) {
      mapModalButton.click()
    }
  }
}

export default toNative(CampsiteAddressAndMap)
</script>

<style scoped>
section {
  display: flex;
}

.map-holder {
  width: 50vw;
  min-height: 55vw;
  display: block;
  position: relative;
  flex-shrink: 0;
  background-color: #e6e4e0;
}

.map-holder :deep(.pu-infowindow) {
  padding: 0.5em;
  display: block;
  text-align: center;
  line-height: 1.2;
  text-decoration: none;
  color: var(--colour-text-default);
}

.location-details {
  text-align: left;
  align-self: center;
  flex-grow: 1;
  padding: 1em 0.5em 1em 1.4em;
}

.address {
  margin-top: 1.25em;
  font-size: var(--body);
}

.address :deep(p) {
  line-height: 1.1;
  margin: 0 0 0.3em 0;
}

/* desktop & tablet */
.desktop .address {
  margin: 0 0 1.25em;
  font-size: inherit;
}

.desktop .location-details :deep(.location-subsection) {
  font-size: inherit;
}
</style>
